import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/suppression")({
  beforeLoad: ({ context }) => guardRoute(context.me, "sarah-suppression"),
  component: Outlet,
});
